import { Badge } from '@mantine/core';

const FLAVOUR_COLORS: Record<string, string> = {
  Taro: '#b29fcb',
  Matcha: '#7ca13e',
  Oolong: '#e68a1f',
  Mango: '#dfd020',
  Jasmine: '#ecc44f',
  Coconut: '#c6a177',
  'Brown Sugar': '#9e7263',
};

export function flavourColor(flavour: string): string | undefined {
  return FLAVOUR_COLORS[flavour];
}

export function FlavourBadge({ flavour }: { flavour: string }) {
  const color = FLAVOUR_COLORS[flavour];
  return color ? (
    <Badge variant="filled" color={color} autoContrast tt="none">
      {flavour}
    </Badge>
  ) : (
    <Badge variant="light" color="brand" tt="none">
      {flavour}
    </Badge>
  );
}
